// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Modal, Button } from "react-bootstrap";
// import {
//   editClass,
//   updateClassOwnerId,
//   createClassOwnershipHistory,
//   shareClass,
// } from "../services/APIClient";

// import "./SaveClassDetails.css";

// function SaveClassDetailsSpecial(props) {
//   const {
//     classDetails,
//     teachers,
//     newClassName,
//     newGrade,
//     newClassTeacherId,
//     gradeLevel,
//     schoolid,
//     isNameUpdated, // Add isNameUpdated to props
//     teacherid, // Add teacherid for ownership history
//     classOwnerId, // Add classOwnerId for ownership history
//     selectedReason, // Add selectedReason for ownership history
//   } = props;
//   const classid = classDetails.id;
//   const navigate = useNavigate();

//   // State to control the modal visibility
//   const [showModal, setShowModal] = useState(false);

//   console.log(newClassName, "NEW CLASS NAME IN SAVE");
//   console.log(newGrade, "NEW GRADE IN SAVE");
//   console.log(gradeLevel, "gradeLevel");
//   console.log(newClassTeacherId, "NEW CLASS TEACHER ID IN SAVE");
//   console.log(teachers, "TEACHERS IN SAVE");
//   console.log(classDetails, "CLASS DETAILS IN SAVE");
//   console.log(classOwnerId, "CLASS OWNER ID IN SAVE");
//   console.log(props, "PROPS IN SAVE");

//   // Prepare class ownership history data
//   const classOwnershipHistoryData = {
//     teacherId: teacherid,
//     oldClassOwner: classOwnerId,
//     newClassOwner: newClassTeacherId,
//     reasonForChangeId: selectedReason?.id, // Use selected reason if provided
//     classownerchangereason: selectedReason?.reason,
//     dateChanged: new Date().toISOString(),
//   };

//   const handleClassEdit = async (e) => {
//     e.preventDefault();

//     // If the name isn't updated, show the modal
//     if (!isNameUpdated) {
//       setShowModal(true);
//       return;
//     }

//     try {
//       // Update class details
//       await editClass(classid, newClassName, gradeLevel);

//       // Update class owner ID if a new teacher is selected
//       if (newClassTeacherId) {
//         await updateClassOwnerId(classid, newClassTeacherId);
//         await shareClass(classid, newClassTeacherId); // Keep this unique functionality from SaveClassDetailsSpecial
//         await createClassOwnershipHistory(classOwnershipHistoryData); // New functionality
//       }

//       // Redirect after saving, forcing the component to re-fetch data
//       navigate(`/class/detail/`, {
//         state: {
//           classDetails: { classDetails },
//           teachers: { teachers },
//           name: { newClassName },
//           gradeLevel: { gradeLevel },
//           schoolid: { schoolid },
//           forceRefreshKey: Date.now(),
//           fromClassDetailsSpecial: true
//         },
//       });
//     } catch (error) {
//       console.error("Error saving class details:", error);
//     }
//   };

//   return (
//     <>
//       <button
//         onClick={handleClassEdit}
//         className="green-button"
//         style={{
//           border: "1px solid #16971b",
//         }}
//       >
//         Save
//       </button>

//       {/* Modal to show when the class name hasn't been updated */}
//       <Modal show={showModal} onHide={() => setShowModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Update Required</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>Please update the class name before saving.</Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// }

// export default SaveClassDetailsSpecial;


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button, Alert } from "react-bootstrap";
import {
  editClass,
  updateClassOwnerId,
  createClassOwnershipHistory,
  shareClass,
  addAdditionalColleagues,
} from "../services/APIClient";

import "./SaveClassDetails.css";

function SaveClassDetailsSpecial(props) {
  const {
    classDetails,
    teachers,
    newClassName,
    newGrade,
    newClassTeacherId,
    gradeLevel,
    schoolid,
    isNameUpdated, // Add isNameUpdated to props
    teacherid, // Add teacherid for ownership history
    classOwnerId, // Add classOwnerId for ownership history
    selectedReason, // Add selectedReason for ownership history
    currentUserInfo, // Add currentUserInfo for teacher invitations
    classOwnerChangeReason, // Add classOwnerChangeReason for the hardcoded reason
  } = props;
  const classid = classDetails.id;
  const navigate = useNavigate();

  // State to control the modal visibility
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [saveError, setSaveError] = useState("");

  console.log(newClassName, "NEW CLASS NAME IN SAVE");
  console.log(newGrade, "NEW GRADE IN SAVE");
  console.log(gradeLevel, "gradeLevel");
  console.log(newClassTeacherId, "NEW CLASS TEACHER ID IN SAVE");
  console.log(teachers, "TEACHERS IN SAVE");
  console.log(classDetails, "CLASS DETAILS IN SAVE");
  console.log(classOwnerId, "CLASS OWNER ID IN SAVE");
  console.log(props, "PROPS IN SAVE");

  // Parse full name into first and last name for API
  const parseFullName = (fullName) => {
    const nameParts = fullName.trim().split(' ');
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ') || '';
    return { firstName, lastName };
  };

  // Check if we're dealing with a new teacher invitation
  const isNewTeacher = newClassTeacherId && 
    typeof newClassTeacherId === 'object' && 
    newClassTeacherId.type === 'new_teacher';

  // Get the actual teacher ID for class ownership updates
  const getTeacherIdForUpdate = () => {
    if (isNewTeacher) {
      // For new teachers, we'll use a placeholder or handle differently
      // The actual teacher ID will be available after they create their account
      return null; // We'll handle this case specially
    }
    return newClassTeacherId;
  };

  // Prepare class ownership history data
  const classOwnershipHistoryData = {
    teacherId: teacherid,
    oldClassOwner: classOwnerId,
    newClassOwner: getTeacherIdForUpdate(),
    reasonForChangeId: selectedReason?.id, // Use selected reason if provided
    classownerchangereason: classOwnerChangeReason || selectedReason?.reason || "Juniors moved to Seniors",
    dateChanged: new Date().toISOString(),
  };

  // Validate new teacher data
  const validateNewTeacherData = () => {
    if (!isNewTeacher) return { isValid: true, message: "" };

    const { name, email, isValid } = newClassTeacherId;
    
    if (!name?.trim()) {
      return { isValid: false, message: "Please enter the teacher's name." };
    }
    
    if (!email?.trim()) {
      return { isValid: false, message: "Please enter the teacher's email address." };
    }
    
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return { isValid: false, message: "Please enter a valid email address." };
    }
    
    // Check if the form component marked it as invalid (e.g., teacher already exists)
    if (isValid === false) {
      return { isValid: false, message: "Please resolve the teacher assignment issues before saving." };
    }
    
    return { isValid: true, message: "" };
  };

  const handleClassEdit = async (e) => {
    e.preventDefault();
    setSaveError("");

    // If the name isn't updated, show the modal
    if (!isNameUpdated) {
      setShowModal(true);
      return;
    }

    // Validate new teacher data if applicable
    const validation = validateNewTeacherData();
    if (!validation.isValid) {
      setSaveError(validation.message);
      return;
    }

    setIsLoading(true);

    try {
      let invitationSent = false;
      let newTeacherEmail = null;

      // First, handle new teacher invitation if needed
      if (isNewTeacher) {
        const { name, email } = newClassTeacherId;
        newTeacherEmail = email;
        
        console.log('Inviting new teacher:', name, email);
        
        const { firstName, lastName } = parseFullName(name);
        
        const colleagues = [{
          firstName,
          lastName,
          email,
          sharedClassId: classid // The class being reassigned
        }];

        try {
          // Send invitation
          await addAdditionalColleagues(
            schoolid,
            currentUserInfo.rollnumber,
            colleagues,
            currentUserInfo.name || "",
            currentUserInfo.countryid || ""
          );
          
          invitationSent = true;
          console.log('New teacher invitation sent successfully');
        } catch (inviteError) {
          console.error('Failed to send teacher invitation:', inviteError);
          
          // Handle specific invitation errors
          let inviteErrorMessage = "Failed to send teacher invitation. ";
          
          if (inviteError.response?.status === 409) {
            inviteErrorMessage += "This teacher may already have been invited or has an account.";
          } else if (inviteError.response?.status === 400) {
            inviteErrorMessage += "Invalid teacher information provided.";
          } else if (inviteError.response?.data?.message) {
            inviteErrorMessage += inviteError.response.data.message;
          } else {
            inviteErrorMessage += "Please try again or invite them manually.";
          }
          
          throw new Error(inviteErrorMessage);
        }
      }

      // Update class details
      await editClass(classid, newClassName, gradeLevel);

      // Update class owner ID if a new teacher is selected (existing teacher only)
      if (newClassTeacherId && !isNewTeacher) {
        await updateClassOwnerId(classid, newClassTeacherId);
        await shareClass(classid, newClassTeacherId);
        await createClassOwnershipHistory(classOwnershipHistoryData);
      } else if (isNewTeacher) {
        // For new teachers, we create a special ownership history entry
        // indicating the class is pending assignment to the new teacher
        const pendingOwnershipData = {
          ...classOwnershipHistoryData,
          newClassOwner: null, // Will be updated when teacher creates account
          pendingTeacherEmail: newTeacherEmail,
          classownerchangereason: `${classOwnerChangeReason || "Juniors moved to Seniors"} - Pending new teacher: ${newClassTeacherId.name}`,
        };
        await createClassOwnershipHistory(pendingOwnershipData);
      }

      // Show success message and redirect
      const successMessage = invitationSent 
        ? `Class updated successfully! An invitation has been sent to ${newTeacherEmail}.`
        : "Class updated successfully!";

      // Redirect after saving, forcing the component to re-fetch data
      navigate(`/class/detail/`, {
        state: {
          classDetails: { classDetails },
          teachers: { teachers },
          name: { newClassName },
          gradeLevel: { gradeLevel },
          schoolid: { schoolid },
          forceRefreshKey: Date.now(),
          fromClassDetailsSpecial: true,
          successMessage: successMessage
        },
      });

    } catch (error) {
      console.error("Error saving class details:", error);
      
      // Use the error message directly if it's already formatted (from invitation errors)
      if (error.message?.includes("invitation") || error.message?.includes("teacher")) {
        setSaveError(error.message);
      } else {
        // Handle other API errors
        let errorMessage = "Error saving class details. Please try again.";
        
        if (error.response?.status === 409) {
          errorMessage = "Conflict detected. Please refresh the page and try again.";
        } else if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        }
        
        setSaveError(errorMessage);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* Show error alert if there's a save error */}
      {saveError && (
        <Alert variant="danger" className="mb-3" onClose={() => setSaveError("")} dismissible>
          {saveError}
        </Alert>
      )}

      <button
        onClick={handleClassEdit}
        className="green-button"
        disabled={isLoading}
        style={{
          border: "1px solid #16971b",
          opacity: isLoading ? 0.6 : 1,
          cursor: isLoading ? "not-allowed" : "pointer"
        }}
      >
        {isLoading ? "Saving..." : "Save"}
        {isNewTeacher && !isLoading && " & Invite Teacher"}
      </button>

      {/* Modal to show when the class name hasn't been updated */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Update Required</Modal.Title>
        </Modal.Header>
        <Modal.Body>Please update the class name before saving.</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SaveClassDetailsSpecial;